import * as User from "./user.actions"
import * as Associations from "./associations.action"
import * as Version from "./version.actions"
import CRUD from "./CRUD.action"
export default { ...User, ...CRUD, ...Associations, ...Version }
